<template>
    <swiper ref="products_swiper" :options="options" class="best-sellers--list">
        <swiper-slide v-for="product in products" v-bind:key="product.id">
            <a v-bind:href="productUrl + '/' + product.id" class="best-sellers--item">
                <img :src="'/upload/' + product.image" alt="" class="best-sellers--img">
                <div class="best-sellers--favourite" v-on:click.prevent="addToFavorites(product.id)">
                    <template v-if="isInclude(product.id)">
                        <svg class="svg-sprite-icon svg-sprite-unstyled icon-hearth-fill">
                            <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-hearth-fill"></use>
                        </svg>
                    </template>
                    <template v-else>
                        <svg class="svg-sprite-icon svg-sprite-unstyled icon-hearth">
                            <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-hearth"></use>
                        </svg>
                    </template>
                </div>
                <p class="best-sellers--price">{{ product.price }} $</p>
                <div class="best-sellers--title">{{ product.title }}</div>
            </a>
        </swiper-slide>
    </swiper>
</template>

<script>
    export default {
        props: {
            products: Array,
            productUrl: {
                type: String,
                required: false
            },
        },
        data: () => ({
            favorites_products: [],
            options: {
                pagination: {
                    el: '.swiper-pagination-products',
                    clickable: true
                },

                navigation: {
                    nextEl: '.swiper-nav-products .swiper-nav--right',
                    prevEl: '.swiper-nav-products .swiper-nav--left'
                },
                slidesPerColumn: 1,
                centeredSlides: false,
                slidesPerView: 1,
                spaceBetween: 50,
                threshold: 7,
                breakpoints: {
                    1500: {
                        slidesPerView: 4,
                        slidesPerColumn: 2,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    571: {
                        slidesPerView: 2,
                    },
                }
            },
        }),

        methods: {
            addToFavorites(product) {
                let products = JSON.parse(localStorage.getItem("products"));
                console.log(products);
                if(products !== null){
                    console.log(typeof(products));
                    if (products.hasOwnProperty(product)) {
                        delete products[product];
                    }else {
                        products[product] = 1;
                    }
                    localStorage.setItem("products", JSON.stringify(products));
                } else{
                    products = {
                        [product]: 1
                    }
                    console.log(products);
                    localStorage.setItem("products", JSON.stringify(products));
                }
                this.getFavorites();
            },
            getFavorites() {
                let products = JSON.parse(localStorage.getItem("products"));
                let favorites_keys = Object.keys(Object.assign({}, products));
                let res = favorites_keys.map(function(item) {
                    return parseInt(item);
                });
                this.favorites_products = res;
            },
            isInclude(product) {
                if(this.favorites_products.length) {
                    return this.favorites_products.includes(product);
                }
                return false;
            }
        },

        mounted() {
            this.getFavorites();
        }
    }
</script>
